import { render, staticRenderFns } from "./FormInputNumberOnboarding.vue?vue&type=template&id=d19a7aae&scoped=true&"
import script from "./FormInputNumberOnboarding.vue?vue&type=script&lang=js&"
export * from "./FormInputNumberOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./FormInputNumberOnboarding.vue?vue&type=style&index=0&id=d19a7aae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19a7aae",
  null
  
)

export default component.exports